import {
  ApplicationInstanceActions,
  ApplicationInstanceReducerState,
  FETCH_APPLICATION_INSTANCE_BY_HOSTID,
  FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_ERROR,
  FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_PENDING,
  FETCH_APPLICATION_INSTANCE_BY_ID,
  FETCH_APPLICATION_INSTANCE_BY_ID_IS_ERROR,
  FETCH_APPLICATION_INSTANCE_BY_ID_IS_PENDING,
  FETCH_APPLICATION_INSTANCE_CRASHES,
  FETCH_APPLICATION_INSTANCE_CRASHES_IS_ERROR,
  FETCH_APPLICATION_INSTANCE_CRASHES_IS_PENDING,
  FETCH_APPLICATION_INSTANCE_TASKS,
  FETCH_APPLICATION_INSTANCE_TASKS_IS_ERROR,
  FETCH_APPLICATION_INSTANCE_TASKS_IS_PENDING,
  FETCH_APPLICATION_INSTANCES,
  FETCH_APPLICATION_INSTANCES_IS_ERROR,
  FETCH_APPLICATION_INSTANCES_IS_PENDING,
  FETCH_APPLICATION_INSTANCES_STATUS,
  FETCH_APPLICATION_INSTANCES_STATUS_IS_ERROR,
  FETCH_APPLICATION_INSTANCES_STATUS_IS_PENDING,
  RESTART_INSTANCE,
  RESTART_INSTANCE_IS_ERROR,
  RESTART_INSTANCE_IS_PENDING,
  START_INSTANCE,
  START_INSTANCE_IS_ERROR,
  START_INSTANCE_IS_PENDING,
  STOP_INSTANCE,
  STOP_INSTANCE_IS_ERROR,
  STOP_INSTANCE_IS_PENDING,
} from 'services/GameHosting/ApplicationInstances/types';

const INITIAL_STATE = {
  applicationInstances: [],
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,

  applicationInstance: undefined,
  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,

  applicationInstancesByHostId: undefined,
  fetchByHostIdIsCompleted: false,
  fetchByHostIdIsPending: false,
  fetchByHostIdIsError: null,

  status: [],
  fetchStatusIsCompleted: false,
  fetchStatusIsPending: false,
  fetchStatusIsError: null,

  tasks: [],
  fetchTasksIsCompleted: false,
  fetchTasksIsPending: false,
  fetchTasksIsError: null,

  crashes: [],
  fetchCrashesIsCompleted: false,
  fetchCrashesIsPending: false,
  fetchCrashesIsError: null,

  startInstanceIdIsCompleted: false,
  startInstanceIdIsPending: false,
  startInstanceIdIsError: null,

  stopInstanceIdIsCompleted: false,
  stopInstanceIdIsPending: false,
  stopInstanceIdIsError: null,

  restartInstanceIdIsCompleted: false,
  restartInstanceIdIsPending: false,
  restartInstanceIdIsError: null,
} satisfies ApplicationInstanceReducerState;

const applicationInstancesReducer = (
  previousState: ApplicationInstanceReducerState | undefined,
  action: ApplicationInstanceActions,
): ApplicationInstanceReducerState => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    // Application instances
    case FETCH_APPLICATION_INSTANCES:
      return {
        ...state,
        applicationInstances: action.data ?? [],
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_APPLICATION_INSTANCES_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_APPLICATION_INSTANCES_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: action.error,
      };

    // Status
    case FETCH_APPLICATION_INSTANCES_STATUS:
      return {
        ...state,
        status: action.data ?? [],
        fetchStatusIsCompleted: true,
        fetchStatusIsPending: false,
        fetchStatusIsError: null,
      };
    case FETCH_APPLICATION_INSTANCES_STATUS_IS_PENDING:
      return {
        ...state,
        fetchStatusIsCompleted: false,
        fetchStatusIsPending: true,
        fetchStatusIsError: null,
      };
    case FETCH_APPLICATION_INSTANCES_STATUS_IS_ERROR:
      return {
        ...state,
        fetchStatusIsCompleted: true,
        fetchStatusIsPending: false,
        fetchStatusIsError: action.error,
      };

    // Instance by id
    case FETCH_APPLICATION_INSTANCE_BY_ID:
      return {
        ...state,
        applicationInstance: action.data,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchByIdIsCompleted: false,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: action.error,
      };

    // Instances by host id
    case FETCH_APPLICATION_INSTANCE_BY_HOSTID:
      return {
        ...state,
        applicationInstancesByHostId: action.data,
        fetchByHostIdIsCompleted: true,
        fetchByHostIdIsPending: false,
        fetchByHostIdIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_PENDING:
      return {
        ...state,
        fetchByHostIdIsCompleted: false,
        fetchByHostIdIsPending: true,
        fetchByHostIdIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_ERROR:
      return {
        ...state,
        fetchByHostIdIsCompleted: true,
        fetchByHostIdIsPending: false,
        fetchByHostIdIsError: action.error,
      };

    // Tasks
    case FETCH_APPLICATION_INSTANCE_TASKS:
      return {
        ...state,
        tasks: action.data ?? [],
        fetchTasksIsCompleted: true,
        fetchTasksIsPending: false,
        fetchTasksIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_TASKS_IS_PENDING:
      return {
        ...state,
        fetchTasksIsCompleted: false,
        fetchTasksIsPending: true,
        fetchTasksIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_TASKS_IS_ERROR:
      return {
        ...state,
        fetchTasksIsCompleted: true,
        fetchTasksIsPending: false,
        fetchTasksIsError: action.error,
      };

    // Crashes
    case FETCH_APPLICATION_INSTANCE_CRASHES:
      return {
        ...state,
        crashes: action.data ?? [],
        fetchCrashesIsCompleted: true,
        fetchCrashesIsPending: false,
        fetchCrashesIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_CRASHES_IS_PENDING:
      return {
        ...state,
        fetchCrashesIsCompleted: false,
        fetchCrashesIsPending: true,
        fetchCrashesIsError: null,
      };
    case FETCH_APPLICATION_INSTANCE_CRASHES_IS_ERROR:
      return {
        ...state,
        fetchCrashesIsCompleted: true,
        fetchCrashesIsPending: false,
        fetchCrashesIsError: action.error,
      };

    // Start instance
    case START_INSTANCE:
      return {
        ...state,
        startInstanceIdIsCompleted: true,
        startInstanceIdIsPending: false,
        startInstanceIdIsError: null,
      };
    case START_INSTANCE_IS_PENDING:
      return {
        ...state,
        startInstanceIdIsCompleted: false,
        startInstanceIdIsPending: true,
        startInstanceIdIsError: null,
      };
    case START_INSTANCE_IS_ERROR:
      return {
        ...state,
        startInstanceIdIsCompleted: true,
        startInstanceIdIsPending: false,
        startInstanceIdIsError: action.error,
      };

    // Stop instance
    case STOP_INSTANCE:
      return {
        ...state,
        stopInstanceIdIsCompleted: true,
        stopInstanceIdIsPending: false,
        stopInstanceIdIsError: null,
      };
    case STOP_INSTANCE_IS_PENDING:
      return {
        ...state,
        stopInstanceIdIsCompleted: false,
        stopInstanceIdIsPending: true,
        stopInstanceIdIsError: null,
      };
    case STOP_INSTANCE_IS_ERROR:
      return {
        ...state,
        stopInstanceIdIsCompleted: true,
        stopInstanceIdIsPending: false,
        stopInstanceIdIsError: action.error,
      };

    // Restart instance
    case RESTART_INSTANCE:
      return {
        ...state,
        restartInstanceIdIsCompleted: true,
        restartInstanceIdIsPending: false,
        restartInstanceIdIsError: null,
      };
    case RESTART_INSTANCE_IS_PENDING:
      return {
        ...state,
        restartInstanceIdIsCompleted: false,
        restartInstanceIdIsPending: true,
        restartInstanceIdIsError: null,
      };
    case RESTART_INSTANCE_IS_ERROR:
      return {
        ...state,
        restartInstanceIdIsCompleted: true,
        restartInstanceIdIsPending: false,
        restartInstanceIdIsError: action.error,
      };

    // Reset reducer
    case 'RESET_REDUCER':
    case 'RESET_APPLICATION_INSTANCES_REDUCER':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default applicationInstancesReducer;
